import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Reverse guard: un usuario autenticado no debe ver /ingreso → va a /inicio. */
export const anonymousGuard: CanMatchFn = (_route, segments) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const target =
    router.currentNavigation()?.initialUrl.toString() ??
    `/${segments.map((segment) => segment.path).join('/')}`;
  if (isRecoveryRoute(target)) return true;
  return auth.isAuthenticated() ? router.createUrlTree(['/inicio']) : true;
};

function isRecoveryRoute(url: string): boolean {
  return /^\/ingreso\/(recuperar-clave|recuperar-usuario|nueva-clave)(?:[/?#]|$)/.test(url);
}
